module.exports = __webpack_public_path__ + "static/fabric-datepicker-manual-input-8deb3cf3fad8fd1bdbe5c885559878b6.gif";